import React from 'react';
import { Grid, Paper, Typography } from '@mui/material';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function MercNetLink() {
    const requiresMercNetLinkIn = useSelector((state) => state.permissions.requiresMercNetLinkIn);

    if (!requiresMercNetLinkIn) {
        return <Navigate to="/literature" />;
    }

    return (
        <Grid container spacing={2} padding={2}>
            <Grid item xs={12}>
                <Paper
                    sx={{
                        p: 2,
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <Typography variant="h6">MercNET</Typography>
                    <Typography variant="body1">
                        MercNET users should access Literature via the link available in MercNET for access to documents.
                        <br />
                        <br />
                        <a href={window.location.host === 'service.mercurymarine.com' ? 'https://mercnet.mercurymarine.com/' :'https://stage-mercnet.mercurymarine.com/us/en.html'}>MercNET Login</a>
                    </Typography>
                </Paper>
            </Grid>
        </Grid>
    );
}